module.exports = __webpack_public_path__ + "img/home-tap-image.6fcc47cd.jpg";